import React from 'react';
import { Plus, Trash2 } from 'lucide-react';

const labelStyle = {
  fontFamily: "'Outfit', sans-serif",
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  textTransform: 'uppercase',
  color: 'var(--text-secondary)',
  marginBottom: '6px',
  display: 'block',
};

export default function FieldFactory({ field, value, onChange }) {
  if (!field) return null;

  switch (field.type) {
    case 'tag': {
      // Handles bullet points/tags lists
      const list = Array.isArray(value) ? value : [];
      
      const handlePointChange = (pIdx, newVal) => {
        const nextList = [...list];
        nextList[pIdx] = newVal;
        onChange(nextList);
      };

      const handleAddPoint = () => {
        onChange([...list, '']);
      };

      const handleDeletePoint = (pIdx) => {
        const nextList = [...list];
        nextList.splice(pIdx, 1);
        onChange(nextList);
      };

      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <label style={labelStyle}>{field.label}</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {list.map((bullet, bIdx) => (
              <div key={bIdx} style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <input
                  type="text"
                  className="p-input"
                  value={bullet || ''}
                  onChange={e => handlePointChange(bIdx, e.target.value)}
                  placeholder={field.placeholder || "Enter details..."}
                  style={{ width: '100%' }}
                />
                <button
                  onClick={() => handleDeletePoint(bIdx)}
                  style={{ background: 'transparent', border: 'none', color: 'var(--status-danger)', cursor: 'pointer' }}
                >
                  <Trash2 size={12} />
                </button>
              </div>
            ))}
            <button
              onClick={handleAddPoint}
              style={{
                background: 'transparent', border: '1px dashed var(--border-default)',
                color: 'var(--brand)', borderRadius: 6, padding: '5px 10px', fontSize: 10.5,
                fontWeight: 700, cursor: 'pointer', width: 'fit-content', display: 'flex', alignItems: 'center', gap: 4
              }}
            >
              <Plus size={11} /> Add Bullet
            </button>
          </div>
        </div>
      );
    }

    case 'textarea':
    case 'richtext':
      return (
        <div>
          <label style={labelStyle}>{field.label}</label>
          <textarea
            className="p-input"
            rows={field.rows || 3}
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            placeholder={field.placeholder || ''}
            style={{ width: '100%' }}
          />
        </div>
      );

    default:
      // Default plain text / email / phone / url / date inputs
      return (
        <div>
          <label style={labelStyle}>{field.label}</label>
          <input
            type={field.type || 'text'}
            className="p-input"
            value={value || ''}
            onChange={e => onChange(e.target.value)}
            placeholder={field.placeholder || ''}
            style={{ width: '100%' }}
          />
        </div>
      );
  }
}
